<template slot-scope="scope">
  <!-- 年度汇算清缴添加 弹窗 -->
  <div>
    <dialogModel
      title="汇算一家"
      width="1200px"
      :visible.sync="Visible"
      @handleClose="handleClose"
      @handleOk="handleConfirm"
    >
      <div class="main-body">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="148px"
          class="demo-ruleForm"
        >
          <div class="section-row">
            <div class="section-block section-left">
              <div class="section-title">企业信息</div>
              <el-form-item label="企业名称：" prop="Purchaser" :required="true">
                <el-select
                  v-model="ruleForm.Purchaser"
                  @change="handelChange"
                  placeholder="请选择企业名称"
                  value-key="companyName"
                >
                  <el-option
                    v-for="item in options1"
                    :key="item.companyName"
                    :label="item.companyName"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="统一社会信用代码："
                prop="PurchaserCode"
                :required="true"
              >
                <div class="readonly-box">{{ ruleForm.PurchaserCode }}</div>
              </el-form-item>

              <el-form-item
                label="法定代表人(负责人)："
                prop="PurchaserName"
                :required="true"
              >
                <div class="readonly-box">{{ ruleForm.PurchaserName }}</div>
              </el-form-item>

              <el-form-item
                label="企业类型："
                prop="customerCompanyType"
                :required="true"
              >
                <el-radio-group
                  v-model="ruleForm.customerCompanyType"
                  :disabled="!EnterpriseIsItOptional"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('customerCompanyType')"
                >
                  <el-radio
                    v-for="item in Arr1"
                    :key="'et-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="纳税类型："
                prop="PayTaxesType"
                :required="true"
              >
                <el-radio-group
                  v-model="ruleForm.PayTaxesType"
                  :disabled="!PayTaxesIsItOptional"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('PayTaxesType')"
                >
                  <el-radio
                    v-for="item in Arr"
                    :key="'pt-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>

            <div class="section-block section-right">
              <div class="section-title">汇算清缴信息</div>
              <el-form-item
                label="联系电话："
                prop="Telephone"
                :required="true"
              >
                <el-input
                  v-model="ruleForm.Telephone"
                  placeholder="请输入联系电话"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="申报年份："
                prop="Declaration"
                :required="true"
              >
                <el-date-picker
                  v-model="ruleForm.Declaration"
                  :clearable="false"
                  type="year"
                  placeholder="请选择申报年份"
                  value-format="yyyy"
                ></el-date-picker>
              </el-form-item>
            </div>
          </div>

          <div class="section-block section-bottom">
            <div class="remark-row">
              <span class="remark-label">备注：</span>
              <div class="remark-box">
                <el-input
                  type="textarea"
                  class="textarea-lg"
                  placeholder="请填写备注，若被列入风险纳税人，请及时说明情况，若没有说明情况，自身承担风险"
                  v-model="ruleForm.textarea"
                  maxlength="1500"
                  show-word-limit
                  resize="none"
                  :rows="5"
                >
                </el-input>
              </div>
            </div>
            <el-form-item label="支付方式：">
              <el-radio-group v-model="payType">
                  <el-radio
                    v-for="item in payTypeArr"
                    :key="'pay-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </dialogModel>
    <!-- 二维码弹窗 -->
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :totalAmount="totalAmount"
      :payMethod="payMethod"
      :orderId="orderId"
      :businessType="businessType"
      :businessIntent="17"
      :queryType="'proxy'"
      @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import { pay } from "../../../../../../../../assets/api/Agency/Enterprise";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../IndexCom/VerificationPwd.vue"; //支付密码验证
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD } from "@/utils/paymentMethods";
export default {
  props: {
    Visible: {},

    options1: {}, //平台企业客户
    enterprise: {}, //平台企业信息
  },
  components: { CommonPayment, VerificationPwd },
  data() {
    return {
      payType: DEFAULT_PAYMENT_METHOD,
      payTypeArr: PAYMENT_OPTIONS, //支付方式选择
      alipayForm: ``,
      totalAmount: "",
      businessType: "",
      payMethod: "",
      orderId: "",
      Arr: [
        { id: 0, name: "小规模纳税人" },
        { id: 1, name: "一般纳税人" },
      ], //纳税类型选项
      Arr1: [
        { id: 0, name: "有限公司" },
        { id: 2, name: "子公司" },
        { id: 3, name: "分公司" },
        { id: 1, name: "个体户" },
        { id: 4, name: "其它" },
      ], //企业类型选项

      ruleForm: {
        Purchaser: "", //购买方
        PurchaserName: "", //法人
        PurchaserId: "", //购买方
        PurchaserCode: "", //购买方统一代码
        PurchaserPhone: "", //购买方联系电话
        customerCompanyType: null, //购买方公司类型
        PurchaseBankName: "", //购买方开户银行名称
        PurchaseAccount: "", //购买方开户账号
        PurchaseAddress: "", //购买方地址
        PayTaxesType: null, //纳税人类型

        Telephone: "", //联系电话
        Declaration: "", //申报年份
        textarea: "", //备注
      },
      rules: {
        // 规则未完善
        Purchaser: [
          {
            required: true,
            message: "请选择企业",
            trigger: ["blur", "change"],
          },
        ],
        PurchaserCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        PurchaserName: [
          {
            required: true,
            message: "法人姓名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        customerCompanyType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: ["blur", "change"],
          },
        ],
        PayTaxesType: [
          {
            required: true,
            message: "请选择纳税类型",
            trigger: ["blur", "change"],
          },
        ],
        Telephone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: ["blur", "change"],
            pattern: /^\s*1[3-9]\d{9}\s*$/,
          },
        ],
        Declaration: [
          {
            required: true,
            message: "请选择申报年份",
            trigger: ["blur", "change"],
          },
        ],
      },
      options: [{ label: "xx", value: "1" }], //公司选择
      VisiblePayment: false,
      paymentPassword: true, //支付密码开启/关闭
      VisiblePwd: false, //支付密码验证
      EnterpriseIsItOptional: true, //企业类型是否可选
      PayTaxesIsItOptional: true, //纳税类型是否可选
    };
  },
  watch: {
    Visible: {
      handler(newSs, old) {
        if (newSs == false) {
          this.ruleForm = {
            Purchaser: "", //购买方
            PurchaserName: "", //法人
            PurchaserId: "", //购买方
            PurchaserCode: "", //购买方统一代码
            PurchaserPhone: "", //购买方联系电话
            customerCompanyType: null, //购买方公司类型
            PurchaseBankName: "", //购买方开户银行名称
            PurchaseAccount: "", //购买方开户账号
            PurchaseAddress: "", //购买方地址
            PayTaxesType: null, //纳税人类型

            Telephone: "", //联系电话
            Declaration: "", //申报年份
            textarea: "", //备注
          };
          this.EnterpriseIsItOptional = true;
          this.PayTaxesIsItOptional = true;
          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 500);
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  methods: {
    //选择购买方
    handelChange(val) {
      this.EnterpriseIsItOptional= true //企业类型是否可选
      this.PayTaxesIsItOptional =  true //纳税类型是否可选
      console.log(val, this.ruleForm.Purchaser, "val");
      this.ruleForm.Purchaser = val.companyName;
      this.ruleForm.PurchaserCode = val.customerCreditCode;
      this.ruleForm.PurchaserPhone = val.phone;
      this.ruleForm.Telephone = val.phone;
      this.ruleForm.PurchaserId = val.id;
      this.ruleForm.PurchaserName = val.legalPerson;
      this.ruleForm.customerCompanyType = val.customerCompanyType;
      this.ruleForm.PurchaseBankName = val.customerBankName;
      this.ruleForm.PurchaseAccount = val.customerBankAccount;
      this.ruleForm.PurchaseAddress = val.customerCompanyAddress;
      this.ruleForm.PayTaxesType = val.customerTaxType;
      this.$refs.ruleForm.clearValidate();
      if (val.customerCompanyType !== null && val.customerCompanyType !== "") {
        // 自动选中企业类型，不可在修改
        this.EnterpriseIsItOptional = false;
      }
      if (val.customerTaxType !== null && val.customerTaxType !== "") {
        // 自动选中纳税类型，不可在修改
        this.PayTaxesIsItOptional = false;
      }
    },
    //付款成功
    handleSuccess() {
      this.VisiblePayment = false;
      this.$emit("handleSuccess");
    },
    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseUp");
    },
    // 确认
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (localStorage.getItem("PaymentPwd") == "false") {
            //没有开启支付密码验证直接弹支付二维码
            this.handleUnderstandPwd();
          } else {
            // 支付密码验证
            this.VisiblePwd = true;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 支付密码确认 正确
    handleUnderstandPwd(pwd) {
      var data = {
        data: {
          businessType: "ANNUAL_CLEARING",
          payMethod: this.payType,
          password: pwd,
          businessInfo: {
            businessData: [
              {
                businessType: 30,
                customerName: this.ruleForm.Purchaser,
                customerCreditCode: this.ruleForm.PurchaserCode,
                customerLegalPerson: this.ruleForm.PurchaserName,
                customerPhone: this.ruleForm.Telephone,
                customerCompanyAddress: this.ruleForm.PurchaseAddress,
                // customerCompanyAddressCode: "411303",
                // price: "0.10",
                reportYear: this.ruleForm.Declaration,
                customerTaxType: this.ruleForm.PayTaxesType,
                customerCompanyType: this.ruleForm.customerCompanyType,
                remark: this.ruleForm.textarea,
              },
            ],
          },
        },
      };

      pay(data).then((res) => {
        if (res.code == 0) {
          console.log(res.data);
          this.VisiblePwd = false;
          this.$tool.PromptBox("success", "操作成功");
          this.alipayForm = res.data.payPage;
          this.totalAmount = res.data.totalAmount;
          this.businessType = res.data.businessType;
          this.payMethod = res.data.payMethod;
          this.orderId = res.data.orderId;

          this.VisiblePayment = true;
          // this.$emit("handleConfirmUp");
        } else {
          this.VisiblePwd = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../bookkeeping-form-dialog.less";
</style>
